import { useMutation } from '@apollo/client'
import { CREATE_USER } from '@graphql/mutation/createUser.mutation'
import { BookingCreateUserMutation, CreateBookingUserRequest } from 'parkdepot-shared/gql/graphql'

export const useCreateUser = () => {
    const [mutation] = useMutation<
        BookingCreateUserMutation,
        {
            request: CreateBookingUserRequest
        }
    >(CREATE_USER)

    const createUser = async (request: CreateBookingUserRequest) => {
        return mutation({
            variables: {
                request
            }
        })
    }

    return {
        createUser
    }
}
